<p-card styleClass="w-full h-full p-4">
  <div class="flex justify-between items-center mb-4">
    <h5>Supervisor Dashboard</h5>
  </div>

  @if (loading()) {
    <div class="flex justify-center items-center py-8">
      <p-progress-spinner styleClass="w-16 h-16"></p-progress-spinner>
    </div>
  } @else {
    @if (hasSupervisees()) {
      <p-tabs [lazy]="true" [value]="supervisees()[0].id" styleClass="supervisor-tabs">
        <p-tablist>
          @for (supervisee of supervisees(); track supervisee.id) {
            <p-tab [value]="supervisee.id" styleClass="supervisor-tab">{{supervisee.first}} {{supervisee.last}}</p-tab>
          }
        </p-tablist>
        <p-tabpanels>
          @for (supervisee of supervisees(); track supervisee.id) {
            <p-tabpanel [value]="supervisee.id" class="supervisor-tabpanel">
              <div class="flex flex-col gap-4">
                <div class="flex flex-col gap-4">
                  <div class="flex flex-row w-full gap-4">
                    <div class="w-full md:w-1/2">
                      <app-my-potential-trips [staffId]="supervisee.id"></app-my-potential-trips>
                    </div>
                    <div class="w-full md:w-1/2">
                      <app-my-consulting-wrapper [staffId]="supervisee.id"></app-my-consulting-wrapper>
                    </div>
                  </div>
                  <div class="flex flex-row w-full gap-4">
                    <div class="w-full md:w-1/2">
                      <app-my-overdue-regi-fees [staffId]="supervisee.id"></app-my-overdue-regi-fees>
                    </div>
                    <div class="w-full md:w-1/2">
                      <app-my-overdue-payments [staffId]="supervisee.id"></app-my-overdue-payments>
                    </div>
                  </div>
                  <div class="flex flex-row w-full gap-4">
                    <div class="w-full md:w-1/3">
                      <app-recruiting-scheduled-activities 
                        [staffId]="supervisee.id" 
                        timeframe="week"
                        [maxHeight]="200">
                      </app-recruiting-scheduled-activities>
                    </div>
                    <div class="w-full md:w-1/3">
                      <app-consulting-scheduled-activities 
                        [staffId]="supervisee.id"
                        [maxHeight]="200">
                      </app-consulting-scheduled-activities>
                    </div>
                    <div class="w-full md:w-1/3">
                      <app-partner-scheduled-activities 
                        [staffId]="supervisee.id"
                        [maxHeight]="200">
                      </app-partner-scheduled-activities>
                    </div>
                  </div>
                  <div>
                    <app-all-scheduled-activities [staffId]="supervisee.id"></app-all-scheduled-activities>
                  </div>
                </div>
              </div>
            </p-tabpanel>
          }
        </p-tabpanels>
      </p-tabs>
    } @else {
      <div class="flex flex-col items-center justify-center py-8 text-center">
        <div class="text-gray-500 mb-4">
          <i class="fas fa-users text-4xl mb-3"></i>
          <h6 class="text-lg font-medium mb-2">No Supervisees Found</h6>
          <p class="text-sm">You don't have any direct reports assigned to you at this time.</p>
        </div>
      </div>
    }
  }
</p-card> 